import { render, staticRenderFns } from "./AddInventoryDetails.vue?vue&type=template&id=0d2dd45e&scoped=true"
import script from "./AddInventoryDetails.vue?vue&type=script&lang=js"
export * from "./AddInventoryDetails.vue?vue&type=script&lang=js"
import style0 from "./AddInventoryDetails.vue?vue&type=style&index=0&id=0d2dd45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2dd45e",
  null
  
)

export default component.exports